export default "__VITE_ASSET__BmZ3Stqn__"